import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EstadoChequePage",
    data() {
        let ss = new MainService();
        return {
            msg: "EstadoChequePage",
            ss: ss,
            ajax: {
                "url": ss.indexEstadoCheque(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            
            estadoCheque: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newEstadoCheque() {
            this.estadoCheque = {};
            this.$refs['frm-estadoCheque'].show();
        },
        showEstadoCheque(id) {
            this.isLoading=true;
            this.ss.showEstadoCheque(id).then(
                (result) => {
                    let response = result.data;
                    this.estadoCheque = response.data;
                    this.$refs['view-estadoCheque'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEstadoCheque() {
            this.$refs['frm-estadoCheque'].show();
            this.$refs['view-estadoCheque'].hide();
        },
        cancelEstadoCheque() {
            if (this.estadoCheque.id) {
                this.$refs['view-estadoCheque'].show();
            }
            this.$refs['frm-estadoCheque'].hide();
        },
        saveEstadoCheque() {
            this.ss.storeEstadoCheque(this.estadoCheque).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-estadoCheque'].hide();
                    this.$refs['datatable-estadoCheque'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEstadoCheque() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEstadoCheque(this.estadoCheque)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-estadoCheque'].hide();
                                this.$refs['datatable-estadoCheque'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-EstadoCheque').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEstadoCheque(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
